export const QUOTE_LINK_ROUTE_PREFIX = '/quote-link';

export const ROUTES_QUOTE_LINK = {
  PDF_TEMPLATE: `${QUOTE_LINK_ROUTE_PREFIX}/pdf-template`,
  EMAIL_TEMPLATE: `${QUOTE_LINK_ROUTE_PREFIX}/email-template`,
  EMAIL_TEMPLATE_STRING: `${QUOTE_LINK_ROUTE_PREFIX}/get-email-template-string`,
};
